export default function EFBattery(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0ZM7.53296 12.1428L11.9971 9.09037C12.2875 8.89182 12.2875 8.46344 11.9971 8.26489L7.53296 5.21248C7.2011 4.98557 6.75074 5.22321 6.75074 5.62522V8.67763V11.73C6.75074 12.1321 7.2011 12.3697 7.53296 12.1428Z"
                fill="black"
            />
        </svg>
    );
}
